<template>
  <div class="py-2 px-2">
    <b-row v-for="(r, iregimenes) in regimenesOrdenados" v-bind:key="iregimenes">
      <b-col cols="12">
        <p class="text-center mb-0 border panel-title-regimen text-uppercase">
          <strong>
            {{ r.nombre != undefined ? r.nombre : "Sin pensión" }}
          </strong>
        </p>
        <p class="text-justify my-2 mx-4 text-danger">
          <small>
            {{ r.descripcion }}
          </small>
        </p>
      </b-col>
      <b-col cols="12" v-for="(h, indexh) in r.habitaciones" v-bind:key="indexh">
        <hr class="d-lg-none" />
        <b-row class="mx-2 hover-hab-as py-0">
          <b-col cols="12" sm="5" lg="5">
            <p v-bind:class="classHab">Habitación {{ h.nombre }}</p>
          </b-col>
          <b-col cols="12" sm="2" lg="3">
            <p class="caption mb-0">
              {{ h.tarifas.tarifa["@attributes"].adl }} Adultos
              {{ toStringMenores(h.menores.edades) }}
            </p>
          </b-col>
          <b-col cols="6" sm="2" lg="2" class="cur-pointer" v-b-tooltip.hover :title="sumarGastos(h.tarifas.tarifa)">
            <p v-bind:class="classTarHab">{{ h.tarifas.tarifa.moneda }} {{ h.tarifas.tarifa.venta }}</p>
          </b-col>
          <b-col cols="6" sm="3" lg="2" class="text-right">
            <div>
              <v-btn
                :icon="$vuetify.breakpoint.xsOnly"
                :flat="!$vuetify.breakpoint.xsOnly"
                :outline="$vuetify.breakpoint.xsOnly"
                small
                color="primary"
                @click="agregar(h)"
                v-if="paraTomar(h)"
                v-html="$vuetify.breakpoint.xsOnly ? '+' : 'Agregar'"
                data-cy="agregarHabi"
              >
              </v-btn>
              <span @click="openModalCancelacion(h)">
                <v-icon
                  :class="
                    (h.cancelacionPenalidad.enGasto == 'true' ? 'text-danger' : 'text-info') + ' ml-1 cur-pointer '
                  "
                  small
                  >info</v-icon
                >
              </span>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12">
        <PanelDescripcionTarifario :tarifarios="r.tarifarios" :idTarifa="r.idTarifa"> </PanelDescripcionTarifario>
      </b-col>
      <b-col cols="12">
        <hr />
      </b-col>
    </b-row>
    <v-dialog persistent v-model="modalData.open" width="500">
      <v-card>
        <v-card-title class="headline red darken-4" primary-title>
          <p class="text-white">
            Politica de cancelación
          </p>
        </v-card-title>

        <v-card-text>
          {{ modalData.txt }}
        </v-card-text>
        <v-card-text class="text-center" v-if="modalData.enGasto">
          Si cancela la reserva de esta habitación, incurrirá en gastos.
          <v-icon name="exclamation-triangle" class="ml-1 text-danger cur-pointer"></v-icon>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="cerrarPoliticas()" data-cy="cerrarPol">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import PanelDescripcionTarifario from "@/components/tarifario/PanelDescripcionTarifario.vue"
import HandlerHabitaciones from "@/assets/js/class/HandlerHabitaciones.js"
import { mapGetters } from "vuex"
export default {
  name: "inicio",
  props: ["data"],
  components: {
    PanelDescripcionTarifario
  },
  mounted() {},
  created() {
    this.prepararHabitaciones()
  },
  data() {
    return {
      regimenes: [],
      regimenesOrdenados: [],
      modalData: { txt: null, enGasto: null, open: false },
      classHab: {
        caption: this.$vuetify.breakpoint.mdAndUp,
        //   'text-center': this.$vuetify.breakpoint.smAndDown,
        "body-2": this.$vuetify.breakpoint.smAndDown,
        "mb-0": true
      },
      classTarHab: {
        caption: this.$vuetify.breakpoint.mdAndUp,
        "mb-0": true,
        "pt-2": true
      }
    }
  },
  methods: {
    isArray() {
      return Array.isArray(this.data.habitaciones.habitacion)
        ? this.data.habitaciones.habitacion
        : [this.data.habitaciones.habitacion]
    },
    toStringMenores(arMenores) {
      if (arMenores.edad === undefined) {
        return ""
      }
      if (Array.isArray(arMenores.edad)) {
        return "+ Menores " + arMenores.edad.toString() + " año/s"
      }
      return "+ Menor " + arMenores.edad + " año/s"
    },
    agregar(habitacion) {
      habitacion["rq"] = this.$store.getters["filtroHoteles/getRq"]
      var aAgregar = { hotel: this.data, habitacion: habitacion }
      var rs = this.$store.dispatch("carrito/agregarHabitacion", aAgregar)
      rs.then(response => {
        this.manejoAgregarHabitacion(response, habitacion)
      })
    },
    manejoAgregarHabitacion(response, habitacion) {
      if (response.agregar) {
        this.openModalCancelacion(habitacion)
        this.showToasted("Habitación agregada al carrito", "success", 2000)
        return
      }
      this.noAgrega()
    },
    noAgrega() {
      const todas = this.validHab.every(valid => valid.tomado)
      if (todas) {
        const mensaje =
          "Recuerde que la selección debe coincidir con la búsqueda, si desea modficar una habitación desmarque una del carrito."
        this.showToasted(mensaje, "info", 5000, "toasted-info-as")
        return
      }
      this.msgErrorAgregar()
    },
    msgErrorAgregar() {
      var maquetado = ""
      this.validHab.forEach(function(v) {
        if (!v.tomado) {
          maquetado = maquetado.concat("<li>" + v.descripcion + "</li>")
        }
      })

      var ultag = "<ul style='margin-top: 10px;'>" + maquetado + "</ul>"
      this.showToasted("Pendiente por seleccionar:", "error", 5000)
      this.showToasted(ultag, "error", 5000)
    },
    openModalCancelacion(h) {
      let _this = this
      this.modalData.txt =
        typeof h.cancelacionPenalidad.description === "undefined"
          ? "Sin detalle de la política."
          : h.cancelacionPenalidad.description
      this.modalData.enGasto = h.cancelacionPenalidad.enGasto === "true"
      this.modalData.open = true
      //  _this.$refs['modal-cancelacion'].show();
    },
    paraTomar(habitacion) {
      try {
        if (habitacion.cancelacionPenalidad.enGasto == undefined) {
          return false
        }
        if (habitacion.cancelacionPenalidad.enGasto == "true") {
          return false
        }
      } catch (e) {
        return false
      }
      return true
    },
    sumarGastos(tarifa) {
      return `La tarifa no incluye iva ${tarifa.moneda} ${tarifa.iva}, ni gastos administrativos ${tarifa.moneda} ${
        tarifa.gasto_administrativo
      } ni el impuesto PAIS ${tarifa.moneda} ${tarifa.afip}
       ni percepción 35% ${tarifa.moneda} ${tarifa.afip2}`
    },
    cerrarPoliticas() {
      this.modalData.open = false
      this.$store.commit("carrito/setOpen", true)
    },
    prepararHabitaciones() {
      const ordenPlanes = this.$store.getters["filtroHoteles/getFiltros"].planes
      let handler = new HandlerHabitaciones(
        this.toArray(this.data.habitaciones.habitacion),
        this.data.proveedor,
        ordenPlanes
      )
      this.regimenesOrdenados = handler.getOrdenados()
    }
  },
  computed: {
    ...mapGetters("carrito", {
      cantServicios: "getCantidadServicios",
      validHab: "getValidHab"
    })
  }
}
</script>
<style scoped>
.panel-title-regimen {
  background-color: #f8f9fa;
}
.hover-hab-as:hover {
  background-color: #f8f9fa;
}
</style>
